import type { SOCSampleWithDocuments } from '../../../types/apiModels'
import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapVoid } from '../../ruutsApi/normalize'

export const createSOCSample = async ({
  socSample,
}: {
  socSample: Partial<SOCSampleWithDocuments>
}): Promise<void> => {
  const response = await apiClient.post(endpoints.monitoringSOCSamples, socSample)
  return unwrapVoid(response)
}
